/* Reveal-on-scroll + image fade-in. Gated by the "Enable animations" setting
   (the script is only loaded when enabled) and by prefers-reduced-motion. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('motion-reduced');
    return;
  }

  function observe(selector, onIntersect) {
    var els = document.querySelectorAll(selector);
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { onIntersect(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          onIntersect(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    observe('[data-animate]', function (el) { el.classList.add('is-revealed'); });
    observe('[data-fade-img]', function (el) { el.classList.add('is-loaded'); });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  // Re-init for sections re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
